/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import Meta from 'quasar/src/plugins/meta/Meta.js';import Notify from 'quasar/src/plugins/notify/Notify.js';import LocalStorage from 'quasar/src/plugins/storage/LocalStorage.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';



export default { config: {"dark":false},plugins: {Meta,Notify,LocalStorage,Dialog} }

